export default {
  data(){
    return {
      isConnectionEntrance        : true,
      connectionTourTemplateType  : 'entrance', // [enterd | entrance]

      connectionTutorial          : {
        options : {
          useKeyboardNavigation: false,
          labels: {
            buttonSkip: 'スキップ',
            buttonPrevious: '前へ',
            buttonNext: '次へ',
            buttonStop: '終了する'
          }
        },

        callbacks : {
          onSkip : () => {
            this.$store.dispatch({
              type  : 'tutorial/updateSingleShouldOpenTour',
              name  : 'connection',
              value : false
            });
          },

          onFinish : () => {
            this.$store.dispatch({
              type  : 'tutorial/updateSingleShouldOpenTour',
              name  : 'connection',
              value : false
            });

            if(this.tourType === 'through'){
              this.$store.dispatch({
                type   : 'tutorial/updateShouldOpenFinal',
                value  : true
              });
            }
          }
        },

        steps : [],

        stepsTemplateUnEnter : [
          {
            target: '.icon-slot-connection',
            content: `こちらはメルティングポットで御座います。あなたの言葉を異世界のタイムラインにのせて交流を楽しみましょう。`
          },
        ],

        stepsTemplateEntered : [
          {
            target: '.icon-slot-connection',
            content: `こちらはメルティングポットで御座います。`
          },
        ],
      }
    }
  },

  watch : {
    connectionTourTemplateType : {
      handler(value){
        switch(value){
          case 'enterd':
            this.connectionTutorial.steps = this.connectionTutorial.stepsTemplateEntered;
          break;

          case 'entrance':
            this.connectionTutorial.steps = this.connectionTutorial.stepsTemplateUnEnter;
          break;
        }
      },
      immediate: true
    },

    characterMetaData : {
      handler(data){
        if(data === {}) return;

        this.isConnectionEntrance = this.characterMetaData['connections.showEntrance'];
      },
      deep: true
    },

    tourType : {
      handler(value){
        // let newSteps = [];
        let stopButtonLabel = '終了する';

        switch(value){
          case 'single':
            // newSteps = this.officeTutorial.stepsTemplate.slice(0, 7);

            stopButtonLabel = '終了する';
          break;

          case 'through':
            // newSteps = this.officeTutorial.stepsTemplate.slice(0, 8);

            stopButtonLabel = '次へ';
          break;
        }

        // this.officeTutorial.steps = newSteps;
        this.connectionTutorial.options.labels.buttonStop = stopButtonLabel;
      },
      immediate: true,
      deep: true
    }
  }
}